import styled from 'styled-components';
import { ProLayout, ProLayoutProps } from '@ant-design/pro-layout';

import { DEVICE_SIZES } from '../../constants/common';

export const Layout = styled(ProLayout)`
  .ant-layout-content {
    padding: 0 !important;
  }

  .ant-layout-header.ant-pro-layout-header {
    background-color: #001529;

    .ant-menu-title-content {
      position: relative;
    }

    .ant-menu-item-selected {
      &::after {
        content: '';
        position: absolute;
        top: calc(100% + 4px);
        left: 0;

        width: 100%;
        height: 2px;

        background-color: #1890ff;
      }
    }

    .ant-menu-item {
      &:hover {
        &::after {
          content: '';
          position: absolute;
          top: calc(100% + 4px);
          left: 0;

          width: 100%;
          height: 2px;

          background-color: #1890ff;
        }
      }
    }

    .ant-menu-light .ant-menu-item a {
      color: #fff;

      &.active {
        color: #1890ff;
      }
    }

    .ant-pro-top-nav-header-main {
      padding-inline-start: 24px;
    }

    @media (max-width: ${DEVICE_SIZES.tablet}) {
      .ant-pro-global-header-header-actions-avatar {
        padding-inline-end: 0px;
      }
    }
  }

  .ant-pro-layout-bg-list {
    background: white;
  }

  .anticon-menu {
    svg {
      color: #fff;
    }
  }
` as React.FC<Omit<ProLayoutProps, 'theme'>>;
